import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import AdmissionFeesComp from './AdmissionFeesComp';

function AdmissionFees() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <AdmissionFeesComp />
      </div>
    </div>
  );
}

export default AdmissionFees;
